import { create } from '../utils.mjs';
import classes from './app-search.module.scss';
import common from '../common.module.scss';

type PanelHeaderOptions = {
	title: string;
	icon?: string;
	onClose?: () => void;
};

export const createPanelHeader = (options: PanelHeaderOptions) => {
	const header = create(`div.${classes.header}`);
	const title = create(`h1 ${options.title}`);

	if (options.icon) {
		header.append(create(`i.far.${options.icon}`));
	}

	const headerButtons = create(`div.${classes.headerButtons}`);

	if (options.onClose) {
		const close = create(`button.${common.button}.${common.buttonSmall}.${common.buttonGhost}`);

		close.append(create('i.far.fa-times'));
		close.addEventListener('click', options.onClose);
		headerButtons.append(close);
	}

	header.append(title, headerButtons);

	return header;
};

type AppSearchElement = {
	moduleFilter?: (app: { name: string }, module: { name: string; type: string }) => boolean;
	showTopModules?: boolean;
	showFavourites?: boolean;
	showAppsInScenario?: boolean;
	closableDetail?: boolean;

	preselectItem?: (direction: 'previous' | 'next') => void;
	selectItem?: () => void;

	detail?: {
		isOpened: boolean;
		close: () => void;
	};
};

type AppSearchConstructor = {
	new (): HTMLElement & AppSearchElement;
};

export const createAppSearch = (options: AppSearchElement = {}) => {
	const AppSearch = window.customElements.get('app-search') as AppSearchConstructor | undefined;

	if (!AppSearch) {
		console.warn('AppSearch component is not registered.');
		return;
	}

	const appSearch = new AppSearch();
	appSearch.showTopModules = options.showTopModules;
	appSearch.showFavourites = options.showFavourites;
	appSearch.showAppsInScenario = options.showAppsInScenario;
	appSearch.moduleFilter = options.moduleFilter;

	return appSearch;
};
